export function mapItemsToDeliveries(order: any) {
  const formattedDeliveries = order.lineItems.reduce((acc: any, item: any) => {
    if (!item.deliveryID) {
      return acc;
    }
    // Find corresponding delivery type for each item
    const deliveryType = order.deliveries.find(
      (delivery: any) => delivery.id === item.deliveryID,
    )?.type;

    // Find existing delivery in the accumulator
    const existingDelivery = acc.find(
      (delivery: any) => delivery.id === item.deliveryID,
    );

    if (existingDelivery) {
      // If delivery exists, push the item into its items array
      existingDelivery.items.push(item);
    } else {
      // If delivery does not exist, create a new one and add it to the accumulator
      acc.push({
        id: item.deliveryID as string,
        type: deliveryType as string,
        items: [item],
      });
    }

    return acc;
  }, []);

  return formattedDeliveries;
}
